import { createProjectVideoLinksApi, deleteProjectVideoLinksApi, editProjectVideoLinksApi, sortProjectVideoLinksApi, } from '../api/videoLinks';
const videoLinksActions = {
    createVideoLinks: async ({ projectId, data }, { setState }) => {
        try {
            const { data: res } = await createProjectVideoLinksApi(projectId, data);
            setState((state) => {
                if (state.project.data) {
                    state.project.data.videoLinks = res.data;
                }
            });
            return res;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
    editVideoLinks: async ({ projectId, data }, { setState }) => {
        try {
            const { data: res } = await editProjectVideoLinksApi(projectId, data);
            setState((state) => {
                if (state.project.data) {
                    state.project.data.videoLinks = res.data;
                }
            });
            return res;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
    sortVideoLinks: async ({ projectId, ids }, { setState }) => {
        try {
            const { data: res } = await sortProjectVideoLinksApi(projectId, { ids });
            setState((state) => {
                if (state.project.data) {
                    state.project.data.videoLinks = res.data;
                }
            });
            return res;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
    deleteVideoLinks: async ({ projectId, ids }, { setState }) => {
        try {
            const { data: res } = await deleteProjectVideoLinksApi(projectId, { ids });
            setState((state) => {
                if (state.project.data?.videoLinks) {
                    state.project.data.videoLinks = state.project.data.videoLinks.filter((link) => !ids.includes(link.id));
                }
            });
            return res;
        }
        catch (error) {
            throw error?.response?.data;
        }
    },
};
export default videoLinksActions;
